import * as React from "react"
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Box
} from '@mui/material'

import NotInterestedIcon from '@mui/icons-material/NotInterested'


import { isEmpty} from "ramda"

import { 
    MpnLookupResult, MpnContractResult 
} from "../types"
import { Paper } from "@mui/material"
import { ThemeProvider, createTheme } from '@mui/material/styles'

import { useState } from "react"

const isNumber = (str: number | string) => /^\d+$/.test(String(str))

const formatCurrency = (cents: number | string) => {
  if (isNumber(cents))
    return `$${(Number(cents) / 100).toFixed(2)}`
    
   return 'N/A'
}

type MpnContractResultProps = { 
    contractResult: MpnContractResult,
    index: number
  }
  
  type MpnContractListProps = { 
    lookupResult: MpnLookupResult,
  }

const MpnContractResultRow = (
    { contractResult, index }: MpnContractResultProps
    ) => {
  
   const { 
    ndc_contract_code, gpo_name, tier_level_code, vendor_contract_type_code,
    vendor, vendor_item_id, item_description, 
    cost, units, start_date, end_date,
} = contractResult
    
const startDateToRender = start_date ? (new Date(start_date)).toLocaleDateString() : 'N/A'

const endDateToRender = end_date ? (new Date(end_date)).toLocaleDateString() : 'N/A'
    
const rowTheme = createTheme({
  typography: {
    fontSize: 13,
  },
})
    return ( 
        
  <ThemeProvider theme={rowTheme} >
      <TableRow 
        key={index}
        hover={true}
        >
        <TableCell align="left">{ndc_contract_code}</TableCell>
        <TableCell align="left">{gpo_name}</TableCell>
        <TableCell align="left">{tier_level_code}</TableCell>
        <TableCell align="left">{vendor_contract_type_code}</TableCell>

        <TableCell align="left">{formatCurrency(cost)}</TableCell>
        <TableCell align="left">{units}</TableCell>
        <TableCell align="left">{startDateToRender}</TableCell>
        <TableCell align="left">{endDateToRender}</TableCell>
      </TableRow>
      </ ThemeProvider>
    )
  }
  

  export const MpnContractResults = (
    { lookupResult }: MpnContractListProps
    ) => {
    
    const { contracts: contractResults } = lookupResult

    // const [noResultsMsg, setNoResultsMsg] = useState(isEmpty(contractResults))


    // if (noResultsMsg)
    //   return (
    //     <div className="alertMsg">
    //       <span>No Contracts Found</span>
    //       <button 
    //           className="hoverable"
    //           onClick={() => setNoResultsMsg(false)}>X</button>
    //     </div> 
    //   )

    if (isEmpty(contractResults))
        return ( 
        <Box 
          sx={{ 
                width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
                marginTop: '10%' 
          }} 
        >
        <NotInterestedIcon sx={{ width: '5%', height: '5%'}} />
                  <span style={{ 
                    font: '12px', color: '#424242', marginTop: '1%'
                    }}>No Contracts Found</span>
        </Box>
        )

    return (
    <TableContainer component={Paper} elevation={3} >
      <Table sx={{ minWidth: 650 }} aria-label="simple table">   
          
          <TableHead>
            <TableRow key={'header-row'} sx={{ fontSize: '40pt' }}>
              <TableCell sx={{ fontWeight: 'bold' }} align="left">Contract Code</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="left">GPO</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="left">Tier</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="left">Type</TableCell>

              <TableCell sx={{ fontWeight: 'bold' }} align="left">Cost</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="left">Units</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="left">Start Date</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="left">End Date</TableCell>
              
            </TableRow>
          </TableHead>
          <TableBody>
            {contractResults.map((contractResult, index) => (
              <MpnContractResultRow 
                contractResult={contractResult}
                index={index}
                />
              ))
            }
          </TableBody>
        </Table>
    </TableContainer>
          
  )
          
}
  
  export default MpnContractResults